import { Component, Input } from '@angular/core'
import {PageService} from '../../../core/services/page.service'
import { SharedDataService } from '../../../core/services/shared-data.service'

@Component({
    selector: 'app-roadmap',
    templateUrl: './roadmap.component.html',
    styleUrls: ['./roadmap.component.scss'],
    standalone: false
})
export class RoadmapComponent {

  equipmentProviderInActive: boolean = false
  constructor(public page: PageService,
    public sharedDataService: SharedDataService
    ) {
     this.equipmentProviderInActive = this.sharedDataService.getPortalType()
    if (this.equipmentProviderInActive) {
      document?.documentElement?.style?.setProperty('--background-color', '#0072BC')
    } else {
      document?.documentElement?.style?.setProperty('--background-color', '#ea731f')
    }
  }
@Input() content: any
@Input() breakpoints: any = {}
currentPoint = 0
  showInfo1 = false
  showInfo2 = false
  showInfo3 = false
  showInfo4 = false

  isCurrentPoint(idx: number): boolean{
    if (this.breakpoints.extraSmall){
      return this.currentPoint === idx
    }
    return true
  }

  toggleShowInfoMobile(id: number) {
    if (this.breakpoints.extraSmall) {
      switch (id) {
        case 1:
          this.toggleShowInfo1()
          break
        case 2:
          this.toggleShowInfo2()
          break
        case 3:
          this.toggleShowInfo3()
          break
        case 4:
          this.toggleShowInfo4()
          break
      }
    }
  }

  toggleShowInfo1() {
    this.showInfo1 = !this.showInfo1
    this.showInfo2 = false
    this.showInfo3 = false
    this.showInfo4 = false
  }
  toggleShowInfo2() {
    this.showInfo1 = false
    this.showInfo2 = !this.showInfo2
    this.showInfo3 = false
    this.showInfo4 = false
  }
  toggleShowInfo3() {
    this.showInfo1 = false
    this.showInfo2 = false
    this.showInfo3 = !this.showInfo3
    this.showInfo4 = false
  }
  toggleShowInfo4() {
    this.showInfo1 = false
    this.showInfo2 = false
    this.showInfo3 = false
    this.showInfo4 = !this.showInfo4
  }
}
